import { Modal } from "antd";
import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";

import { useLoc } from "@app/shared/lib/hooks";

import { useUIAppState } from "../../UIAppStateProvider";
import { StudentProfileForm } from "../StudentProfileForm/StudentProfileForm";

export const StudentProfileModal: FC = () => {
  const loc = useLoc();

  const UIAppState = useUIAppState();

  const { notifications } = useParams<{ notifications?: string }>();

  useEffect(() => {
    if (!notifications) return;
    UIAppState.setIsProfileDrawerVisible(true, "notifications");
  }, [UIAppState, notifications]);

  return (
    <Modal
      open={UIAppState.isProfileDrawerVisible}
      title={loc.word("User profile")}
      width={600}
      destroyOnClose
      onCancel={() => UIAppState.setIsProfileDrawerVisible(false)}
      footer={null}
      className="p-0"
    >
      <StudentProfileForm
        viewMode="default"
        defaultTab={UIAppState.defaultProfileTab}
        onSave={() => UIAppState.setIsProfileDrawerVisible(false)}
      />
    </Modal>
  );
};
